import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from '../component.styles';

const CSS_PREFIX = 'vds-listbox';

const CybsListboxList = forwardRef(
  (
    {
      children,
      className,
      customCSS,
      multiselect,
      // eslint-disable-next-line react/prop-types
      numberOfItems,
      role,
      ...remainingProps
    },
    ref
  ) => (
    <ul
      className={classnames(
        CSS_PREFIX,
        {
          'vds-select--multi': Boolean(multiselect)
        },
        className
      )}
      css={theme => [styles(theme), customCSS(theme)]}
      data-number-items={numberOfItems}
      ref={ref}
      role={role}
      {...remainingProps}
    >
      {children}
    </ul>
  )
);

CybsListboxList.propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Styling function to allow CSS overrides via Emotion
   *
   * @ignore
   */
  customCSS: PropTypes.func,

  /**
   * Multi select
   */
  multiselect: PropTypes.bool,

  /**
   * Role
   */
  role: PropTypes.string
};

CybsListboxList.defaultProps = {
  children: undefined,
  className: undefined,
  customCSS: () => '',
  multiselect: false,
  role: 'listbox'
};

CybsListboxList.displayName = 'CybsListboxList';

export default CybsListboxList;
